import {AfterViewChecked, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {Saisine} from './saisine.model';
import {Principal} from '../../shared/auth/principal.service';
import {UtilsService} from '../../shared/utils/utils.service';
import {PropositionStatus} from '../master-proposal/master-proposal.model';
import {isNullOrUndefined} from 'util';

@Component({
    selector: 'jhi-saisine-master-proposals',
    templateUrl: './saisine-master-proposals.component.html'
})
export class SaisineMasterProposalsComponent implements OnInit, AfterViewChecked {

    @Input() saisine: Saisine;

    statusOptions: any[];
    selectStatus: any[];

    // Table master proposals
    @ViewChild('dtMasterProposals') dtMasterProposals;
    multiSortMetaDtMasterProposals: any[];
    statusFilterDtMasterProposals: any[];
    schoolFilterDtMasterProposals: string;


    constructor(
        public principal: Principal,
        public utilsService: UtilsService,
        public elementRef: ElementRef) {}

    ngOnInit() {
        this.initSortRole();
    }

    ngAfterViewChecked(): void {
        this.changeBgColorStatusSuggestedBySchool();
    }

    initSortRole(): void {
        this.selectStatus = [];
        this.statusOptions = this.utilsService.getRxADialogueStatus();

        this.multiSortMetaDtMasterProposals = [];
        this.multiSortMetaDtMasterProposals.push({field: 'schoolProposalDate', order: -1});

        this.statusFilterDtMasterProposals = [PropositionStatus.REJECTED, PropositionStatus.ACCEPTED, PropositionStatus.SUBMITTED, PropositionStatus.CANCELED];
        this.schoolFilterDtMasterProposals = '';

        if (this.principal.isSchoolProfile()) {
            this.statusOptions = this.utilsService.getEtablissementPropositionOptions();
            this.schoolFilterDtMasterProposals = this.principal.getSchoolUai();
        }
    }

    reapplyInitSortFilter(): void {
        this.dtMasterProposals.reset();
        this.selectStatus = [];
        this.initSortRole();
        this.dtMasterProposals.multiSortMetaDtMasterProposals = this.multiSortMetaDtMasterProposals;
        this.dtMasterProposals.sortMultiple();
    }

    changeBgColorStatusSuggestedBySchool(): void {
        let elems = this.elementRef.nativeElement.querySelectorAll('.columnSuggestedBySchool-true');
        for (let i = 0; i < elems.length; i++) {
            if (!isNullOrUndefined(elems[i])) {
                let parentElem = elems[i].parentElement;
                if (!isNullOrUndefined(parentElem)) {
                    let column = parentElem.parentElement;
                    if (!isNullOrUndefined(column)) {
                        column.style.backgroundColor = '#5bc0de';
                    }
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/saisine/saisine-master-proposals.component.ts